export const REQUIRED_TRANSACTIONS = [
  'T02400',
  'T02500',
  'T04100',
  'T08500',
  'T08600',
  'T04300',
  'T09600',
  'T09700',
  'T09800',
  'T10200',
  'T10300',
  'T10400',
  'T10500',
  'T07500',
  'T00100',
  'T08900',
  'T00400',
  'T24100',
  'T00300',
  'T04402',
];

export const hasTransfersAccess = data =>
  data.T02400 !== undefined ||
  data.T02500 !== undefined ||
  data.T04100 !== undefined ||
  data.T08500 !== undefined ||
  data.T08600 !== undefined ||
  data.T04300 !== undefined ||
  data.T09600 !== undefined ||
  data.T09700 !== undefined ||
  data.T09800 !== undefined ||
  data.T10200 !== undefined ||
  data.T10300 !== undefined ||
  data.T10400 !== undefined ||
  data.T10500 !== undefined ||
  data.T07500 !== undefined;

export const hasServicesPaymentsAccess = data =>
  (data.T00100 !== undefined || data.T08900 !== undefined || data.T00400 !== undefined) && data.T24100 !== undefined;

export const hasAccountSummaryResumeAccess = data =>
  (data.T00300 !== undefined && data.T04402 !== undefined) || (data.T00100 !== undefined && data.T00500 !== undefined);

export const showShortcuts = transactions =>
  hasTransfersAccess(transactions) &&
  hasServicesPaymentsAccess(transactions) &&
  hasAccountSummaryResumeAccess(transactions);

export const hasCheckingAccountStatementEnabled = data =>
  data.T00100 &&
  data.T00100.prd &&
  ((typeof data.T00100.prd === 'string' && data.T00100.prd.length > 0) || data.T00100.prd.length > 0);
